import type { Locale } from '../../i18n';

const RU = {
  'billing.title': 'Подписка',
  'billing.subtitle': 'Тарифные планы, подписки клиентов, отток и настройки списания',
  'billing.loading': 'Загрузка…',
  'billing.refresh': 'Обновить',
  'billing.empty': 'Нет данных',
  'billing.save': 'Сохранить',
  'billing.cancel': 'Отмена',

  'billing.tab.plans': 'Планы',
  'billing.tab.lookup': 'Подписки',
  'billing.tab.churn': 'Отток',
  'billing.tab.policies': 'Настройки',
  'billing.tab.sell': 'Оформить',
  'billing.tab.retention': 'Удержание',
  'billing.plans.maxVehicles': 'Машин в подписке',
  'billing.reason.vehicle_not_owned': 'Автомобиль больше не связан с клиентом подписки',
  'billing.sell.title': 'Оформить подписку',
  'billing.sell.hint':
    'Клиент, его автомобиль и план из продажи. Подписка оформляется только на машину, с которой клиент связан; первый период списывается сразу, если отмечено.',
  'billing.sell.customer': 'Клиент',
  'billing.sell.vehicle': 'Автомобиль клиента',
  'billing.sell.noVehicles': 'У клиента нет привязанных автомобилей — привяжите машину в карточке клиента',
  'billing.sell.plan': 'План',
  'billing.sell.autorenew': 'Продлевать автоматически',
  'billing.sell.chargeNow': 'Списать первый период сейчас',
  'billing.sell.submit': 'Оформить подписку',
  'billing.sell.done': 'Подписка оформлена: {status}',
  'billing.vehicles.title': 'Автомобили подписки',
  'billing.vehicles.primary': 'основная',
  'billing.vehicles.member': 'семейная',
  'billing.vehicles.removed': 'снята {when}: {reason}',
  'billing.vehicles.unlinked': 'связь с клиентом закрыта — не покрывается',
  'billing.vehicles.change': 'Перенести подписку на другую машину',
  'billing.vehicles.release': 'Клиент больше не ездит на прежней машине',
  'billing.vehicles.changeSubmit': 'Перенести',
  'billing.vehicles.add': 'Добавить машину в семейный план',
  'billing.vehicles.asDriver': 'Машина члена семьи — привязать клиента водителем',
  'billing.vehicles.addSubmit': 'Добавить',
  'billing.vehicles.remove': 'Снять',
  'billing.vehicles.removeReason': 'Снята из админки',
  'billing.vehicles.saved': 'Состав подписки обновлён',
  'billing.retention.title': 'Сценарии удержания и возврата',
  'billing.retention.hint':
    'Задача проходит сценарии раз в час и отправляет сообщение по шаблону события. Возврат и предложения — маркетинг: уходят только клиентам с согласием.',
  'billing.retention.enabled': 'Включён',
  'billing.retention.delay': 'Через, дней',
  'billing.retention.cooldown': 'Не чаще, дней',
  'billing.retention.offer': 'Предложение',
  'billing.retention.save': 'Сохранить',
  'billing.retention.saved': 'Сценарий сохранён',
  'billing.retention.run': 'Запустить сейчас',
  'billing.retention.ran': 'Сработало касаний: {total}',
  'billing.retention.touches': 'Последние касания',
  'billing.retention.noTouches': 'Сценарии ещё не срабатывали',
  'billing.retention.when': 'Когда',
  'billing.retention.customer': 'Клиент',
  'billing.retention.scenario': 'Сценарий',
  'billing.retention.code.dunning': 'Неудачное списание',
  'billing.retention.code.renewal_reminder': 'Напоминание о продлении',
  'billing.retention.code.cancel_save': 'Предложение остаться после отмены',
  'billing.retention.code.winback': 'Возврат бывшего подписчика',
  'billing.retention.code.return': 'Возврат давно не приезжавшего',

  'billing.plans.title': 'Тарифные планы',
  'billing.plans.code': 'Код',
  'billing.plans.name': 'Название',
  'billing.plans.period': 'Период',
  'billing.plans.price': 'Цена, ₸',
  'billing.plans.limit': 'Моек в периоде',
  'billing.plans.perDay': 'Моек в день',
  'billing.plans.status': 'Статус',
  'billing.plans.create': 'Завести план',
  'billing.plans.archive': 'Снять с продажи',
  'billing.plans.restore': 'Вернуть в продажу',
  'billing.plans.unlimited': 'Без ограничения',

  'billing.period.month': 'Месяц',
  'billing.period.quarter': 'Квартал',
  'billing.period.year': 'Год',

  'billing.status.active': 'Активен',
  'billing.status.archived': 'Снят с продажи',
  'billing.status.pending': 'Ожидает оплаты',
  'billing.status.past_due': 'Просрочена',
  'billing.status.paused': 'Приостановлена',
  'billing.status.cancelled': 'Отменена',
  'billing.status.expired': 'Истекла',

  'billing.lookup.title': 'Поиск подписки',
  'billing.lookup.byVehicle': 'Проверка по номеру автомобиля',
  'billing.lookup.vehiclePlaceholder': 'Номер автомобиля',
  'billing.lookup.byCustomer': 'Подписки клиента',
  'billing.lookup.noSubs': 'У клиента нет ни одной подписки — ни действующей, ни отменённой.',
  'billing.lookup.byId': 'Карточка по идентификатору подписки',
  'billing.lookup.idPlaceholder': 'Идентификатор подписки',
  'billing.lookup.idHint':
    'Служебный поиск: идентификатор берут из журнала или из ссылки на карточку. Обычный путь — найти клиента выше и открыть подписку из списка.',
  'billing.lookup.find': 'Найти',
  'billing.lookup.covered': 'Визит покрыт подпиской',
  'billing.lookup.notCovered': 'Визит не покрыт',
  'billing.lookup.usesLeft': 'Осталось моек',
  'billing.lookup.credits': 'Перенесённые мойки',
  'billing.lookup.periodEnd': 'Оплачено до',
  'billing.lookup.nextAllowed': 'Следующая мойка не раньше',

  'billing.reason.ok': 'Покрыто',
  'billing.reason.no_subscription': 'Подписки на этом автомобиле нет',
  'billing.reason.not_active': 'Подписка неактивна',
  'billing.reason.period_ended': 'Оплаченный период закончился',
  'billing.reason.limit_exceeded': 'Исчерпан лимит моек',
  'billing.reason.too_frequent': 'Слишком частое использование',

  'billing.card.title': 'Карточка подписки',
  'billing.card.plan': 'План',
  'billing.card.status': 'Статус',
  'billing.card.periodEnd': 'Оплачено до',
  'billing.card.autorenew': 'Автопродление',
  'billing.card.pause': 'Приостановить',
  'billing.card.resume': 'Возобновить',
  'billing.card.cancelSub': 'Отменить',
  'billing.card.charge': 'Списать сейчас',
  'billing.card.charged': 'Списание выполнено',
  'billing.card.charges': 'Списания',
  'billing.card.transitions': 'История статусов',
  'billing.card.chargePeriod': 'Период',
  'billing.card.chargeAttempt': 'Попытка',
  'billing.card.chargeStatus': 'Статус',
  'billing.card.chargeReason': 'Причина отказа',
  'billing.card.chargeNext': 'Следующая попытка',
  'billing.card.transitionFrom': 'Из',
  'billing.card.transitionTo': 'В',
  'billing.card.transitionWhen': 'Когда',

  'billing.churn.title': 'Отток по подписке',
  'billing.churn.from': 'С',
  'billing.churn.to': 'По',
  'billing.churn.activeAtStart': 'Активных на начало',
  'billing.churn.activated': 'Подключений',
  'billing.churn.cancelled': 'Отписок',
  'billing.churn.expired': 'Истекло без продления',
  'billing.churn.rate': 'Отток',
  'billing.churn.activeAtEnd': 'Активных на конец',
  'billing.churn.byMonth': 'По месяцам',
  'billing.churn.byPlan': 'По планам',
  'billing.churn.month': 'Месяц',
  'billing.churn.definition':
    'Отток = отписки за период / активные подписки на начало периода. Источник — журнал переходов.',

  'billing.policies.title': 'Настройки подписки',
  'billing.policies.charge': 'Автосписание и повторы',
  'billing.policies.maxAttempts': 'Число попыток',
  'billing.policies.intervals': 'Интервалы повторов, часы',
  'billing.policies.grace': 'Отсрочка, часы',
  'billing.policies.reminder': 'Напоминание за, дней',
  'billing.policies.usage': 'Лимиты и антифрод',
  'billing.policies.perPeriod': 'Моек в периоде по умолчанию',
  'billing.policies.perDay': 'Моек в день',
  'billing.policies.minHours': 'Минимум часов между мойками',
  'billing.policies.vehicle': 'Проверять привязку к автомобилю',
  'billing.policies.conversion': 'Перевод абонементов',
  'billing.policies.strategy': 'Правило перевода',
  'billing.policies.carry_over': 'Перенести неиспользованные мойки',
  'billing.policies.extend_period': 'Продлить оплаченный срок',
  'billing.policies.customer_choice': 'Предложить выбор клиенту',
  'billing.policies.conversionNote':
    'Правило согласуется с заказчиком. Потеря оплаченного клиентом объёма недопустима при любом выборе.',
  'billing.policies.saved': 'Настройки сохранены',
  'billing.policies.save': 'Сохранить настройки',
  'billing.policies.dirty': 'Есть несохранённые изменения',
  'billing.policies.attemptsHint':
    'Первая попытка — не повтор, поэтому интервалов нужно на один меньше. Сейчас интервалов {intervals}, значит попыток не больше {max}.',
  'billing.policies.intervalsHint':
    'Часы через запятую. Каждый интервал — пауза перед очередной попыткой списания.',
};

const KK: Record<keyof typeof RU, string> = {
  'billing.title': 'Жазылым',
  'billing.subtitle': 'Тарифтік жоспарлар, клиент жазылымдары, кетім және есептен шығару баптаулары',
  'billing.loading': 'Жүктелуде…',
  'billing.refresh': 'Жаңарту',
  'billing.empty': 'Дерек жоқ',
  'billing.save': 'Сақтау',
  'billing.cancel': 'Бас тарту',

  'billing.tab.plans': 'Жоспарлар',
  'billing.tab.lookup': 'Жазылымдар',
  'billing.tab.churn': 'Кету',
  'billing.tab.policies': 'Баптаулар',
  'billing.tab.sell': 'Рәсімдеу',
  'billing.tab.retention': 'Ұстап қалу',
  'billing.plans.maxVehicles': 'Жазылымдағы көлік саны',
  'billing.reason.vehicle_not_owned': 'Көлік енді жазылым клиентімен байланысты емес',
  'billing.sell.title': 'Жазылымды рәсімдеу',
  'billing.sell.hint':
    'Клиент, оның көлігі және сатылымдағы жоспар. Жазылым тек клиентпен байланысты көлікке рәсімделеді; белгіленсе, бірінші кезең бірден есептен шығарылады.',
  'billing.sell.customer': 'Клиент',
  'billing.sell.vehicle': 'Клиенттің көлігі',
  'billing.sell.noVehicles': 'Клиентте байланған көлік жоқ — көлікті клиент картасында байлаңыз',
  'billing.sell.plan': 'Жоспар',
  'billing.sell.autorenew': 'Автоматты түрде ұзарту',
  'billing.sell.chargeNow': 'Бірінші кезеңді қазір есептен шығару',
  'billing.sell.submit': 'Жазылымды рәсімдеу',
  'billing.sell.done': 'Жазылым рәсімделді: {status}',
  'billing.vehicles.title': 'Жазылым көліктері',
  'billing.vehicles.primary': 'негізгі',
  'billing.vehicles.member': 'отбасылық',
  'billing.vehicles.removed': '{when} алынды: {reason}',
  'billing.vehicles.unlinked': 'клиентпен байланыс жабылған — өтелмейді',
  'billing.vehicles.change': 'Жазылымды басқа көлікке ауыстыру',
  'billing.vehicles.release': 'Клиент бұрынғы көлікті енді айдамайды',
  'billing.vehicles.changeSubmit': 'Ауыстыру',
  'billing.vehicles.add': 'Отбасылық жоспарға көлік қосу',
  'billing.vehicles.asDriver': 'Отбасы мүшесінің көлігі — клиентті жүргізуші ретінде байлау',
  'billing.vehicles.addSubmit': 'Қосу',
  'billing.vehicles.remove': 'Алу',
  'billing.vehicles.removeReason': 'Әкімшіліктен алынды',
  'billing.vehicles.saved': 'Жазылым құрамы жаңартылды',
  'billing.retention.title': 'Ұстап қалу және қайтару сценарийлері',
  'billing.retention.hint':
    'Тапсырма сценарийлерді сағатына бір рет өтіп, оқиға үлгісі бойынша хабар жібереді. Қайтару мен ұсыныстар — маркетинг: тек келісімі бар клиенттерге кетеді.',
  'billing.retention.enabled': 'Қосулы',
  'billing.retention.delay': 'Неше күннен кейін',
  'billing.retention.cooldown': 'Жиілігі, күн',
  'billing.retention.offer': 'Ұсыныс',
  'billing.retention.save': 'Сақтау',
  'billing.retention.saved': 'Сценарий сақталды',
  'billing.retention.run': 'Қазір іске қосу',
  'billing.retention.ran': 'Жанасулар саны: {total}',
  'billing.retention.touches': 'Соңғы жанасулар',
  'billing.retention.noTouches': 'Сценарийлер әлі іске қосылмаған',
  'billing.retention.when': 'Қашан',
  'billing.retention.customer': 'Клиент',
  'billing.retention.scenario': 'Сценарий',
  'billing.retention.code.dunning': 'Сәтсіз есептен шығару',
  'billing.retention.code.renewal_reminder': 'Ұзарту туралы еске салу',
  'billing.retention.code.cancel_save': 'Бас тартқаннан кейін қалу ұсынысы',
  'billing.retention.code.winback': 'Бұрынғы жазылушыны қайтару',
  'billing.retention.code.return': 'Көптен келмеген клиентті қайтару',

  'billing.plans.title': 'Тарифтік жоспарлар',
  'billing.plans.code': 'Коды',
  'billing.plans.name': 'Атауы',
  'billing.plans.period': 'Кезең',
  'billing.plans.price': 'Бағасы, ₸',
  'billing.plans.limit': 'Кезеңдегі жуу саны',
  'billing.plans.perDay': 'Күніне жуу саны',
  'billing.plans.status': 'Күйі',
  'billing.plans.create': 'Жоспар қосу',
  'billing.plans.archive': 'Сатудан алу',
  'billing.plans.restore': 'Сатуға қайтару',
  'billing.plans.unlimited': 'Шектеусіз',

  'billing.period.month': 'Ай',
  'billing.period.quarter': 'Тоқсан',
  'billing.period.year': 'Жыл',

  'billing.status.active': 'Белсенді',
  'billing.status.archived': 'Сатудан алынған',
  'billing.status.pending': 'Төлемді күтуде',
  'billing.status.past_due': 'Мерзімі өткен',
  'billing.status.paused': 'Тоқтатылған',
  'billing.status.cancelled': 'Бас тартылған',
  'billing.status.expired': 'Мерзімі бітті',

  'billing.lookup.title': 'Жазылымды іздеу',
  'billing.lookup.byVehicle': 'Көлік нөмірі бойынша тексеру',
  'billing.lookup.vehiclePlaceholder': 'Көлік нөмірі',
  'billing.lookup.byCustomer': 'Клиенттің жазылымдары',
  'billing.lookup.noSubs': 'Клиентте бірде-бір жазылым жоқ — қолданыстағы да, тоқтатылған да.',
  'billing.lookup.byId': 'Жазылым идентификаторы бойынша карта',
  'billing.lookup.idPlaceholder': 'Жазылым идентификаторы',
  'billing.lookup.idHint':
    'Қызметтік іздеу: идентификатор журналдан немесе карта сілтемесінен алынады. Әдеттегі жол — жоғарыда клиентті тауып, тізімнен жазылымды ашу.',
  'billing.lookup.find': 'Табу',
  'billing.lookup.covered': 'Келу жазылыммен қамтылған',
  'billing.lookup.notCovered': 'Келу қамтылмаған',
  'billing.lookup.usesLeft': 'Қалған жуу саны',
  'billing.lookup.credits': 'Ауыстырылған жуулар',
  'billing.lookup.periodEnd': 'Төленген мерзімі',
  'billing.lookup.nextAllowed': 'Келесі жуу ерте емес',

  'billing.reason.ok': 'Қамтылған',
  'billing.reason.no_subscription': 'Бұл көлікте жазылым жоқ',
  'billing.reason.not_active': 'Жазылым белсенді емес',
  'billing.reason.period_ended': 'Төленген кезең аяқталды',
  'billing.reason.limit_exceeded': 'Жуу лимиті таусылды',
  'billing.reason.too_frequent': 'Тым жиі пайдалану',

  'billing.card.title': 'Жазылым картасы',
  'billing.card.plan': 'Жоспар',
  'billing.card.status': 'Күйі',
  'billing.card.periodEnd': 'Төленген мерзімі',
  'billing.card.autorenew': 'Автоматты ұзарту',
  'billing.card.pause': 'Тоқтату',
  'billing.card.resume': 'Жалғастыру',
  'billing.card.cancelSub': 'Бас тарту',
  'billing.card.charge': 'Қазір есептен шығару',
  'billing.card.charged': 'Есептен шығару орындалды',
  'billing.card.charges': 'Есептен шығарулар',
  'billing.card.transitions': 'Күй тарихы',
  'billing.card.chargePeriod': 'Кезең',
  'billing.card.chargeAttempt': 'Әрекет',
  'billing.card.chargeStatus': 'Күйі',
  'billing.card.chargeReason': 'Бас тарту себебі',
  'billing.card.chargeNext': 'Келесі әрекет',
  'billing.card.transitionFrom': 'Қайдан',
  'billing.card.transitionTo': 'Қайда',
  'billing.card.transitionWhen': 'Қашан',

  'billing.churn.title': 'Жазылым бойынша кету',
  'billing.churn.from': 'Бастап',
  'billing.churn.to': 'Дейін',
  'billing.churn.activeAtStart': 'Басында белсенді',
  'billing.churn.activated': 'Қосылулар',
  'billing.churn.cancelled': 'Бас тартулар',
  'billing.churn.expired': 'Ұзартусыз аяқталды',
  'billing.churn.rate': 'Кету',
  'billing.churn.activeAtEnd': 'Соңында белсенді',
  'billing.churn.byMonth': 'Айлар бойынша',
  'billing.churn.byPlan': 'Жоспарлар бойынша',
  'billing.churn.month': 'Ай',
  'billing.churn.definition':
    'Кету = кезеңдегі бас тартулар / кезең басындағы белсенді жазылымдар. Дереккөз — ауысулар журналы.',

  'billing.policies.title': 'Жазылым баптаулары',
  'billing.policies.charge': 'Автоматты есептен шығару және қайталаулар',
  'billing.policies.maxAttempts': 'Әрекет саны',
  'billing.policies.intervals': 'Қайталау аралықтары, сағат',
  'billing.policies.grace': 'Кейінге қалдыру, сағат',
  'billing.policies.reminder': 'Еске салу, күн бұрын',
  'billing.policies.usage': 'Лимиттер және теріс пайдалану',
  'billing.policies.perPeriod': 'Әдепкі кезеңдегі жуу саны',
  'billing.policies.perDay': 'Күніне жуу саны',
  'billing.policies.minHours': 'Жуулар арасындағы ең аз сағат',
  'billing.policies.vehicle': 'Көлікке байланысын тексеру',
  'billing.policies.conversion': 'Абонементтерді ауыстыру',
  'billing.policies.strategy': 'Ауыстыру ережесі',
  'billing.policies.carry_over': 'Пайдаланылмаған жууларды ауыстыру',
  'billing.policies.extend_period': 'Төленген мерзімді ұзарту',
  'billing.policies.customer_choice': 'Клиентке таңдау ұсыну',
  'billing.policies.conversionNote':
    'Ереже тапсырыс берушімен келісіледі. Кез келген таңдауда клиент төлеген көлемнің жоғалуы жол берілмейді.',
  'billing.policies.saved': 'Баптаулар сақталды',
  'billing.policies.save': 'Баптауларды сақтау',
  'billing.policies.dirty': 'Сақталмаған өзгерістер бар',
  'billing.policies.attemptsHint':
    'Бірінші әрекет — қайталау емес, сондықтан аралық бір азырақ керек. Қазір аралық {intervals}, демек әрекет саны {max} аспайды.',
  'billing.policies.intervalsHint':
    'Сағаттар үтір арқылы. Әр аралық — кезекті есептен шығару әрекетінің алдындағы үзіліс.',
};

export type BillingKey = keyof typeof RU;
export type BillingTranslate = (
  key: BillingKey,
  params?: Readonly<Record<string, string | number>>,
) => string;

export function billingStrings(locale: Locale): BillingTranslate {
  const dict: Record<string, string> = locale === 'kk' ? KK : RU;
  return (key, params) => {
    const template = dict[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}
